import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, Flex, Text } from "@mantine/core";

import type { CompanyDefaultStatementWarning } from "./company-default-statement-warnings";

const WARNING_BADGE_TEXT_COLOR = "#3d2a00";

interface StatementWarningProps {
  testId: string;
  warning: CompanyDefaultStatementWarning;
}

export const StatementWarning = ({
  testId,
  warning,
}: StatementWarningProps) => (
  <Flex
    align="flex-start"
    aria-live="polite"
    className="mt-2 rounded border border-solid border-[#e6a32b] bg-[#fff4dc] px-3 py-2 text-[#3d2a00]"
    data-testid={testId}
    gap={10}
  >
    <FontAwesomeIcon
      className="mt-0.5 shrink-0 text-[#6b4500]"
      icon={faTriangleExclamation}
    />
    <Flex direction="column" gap={6}>
      <Flex align="center" gap={8} wrap="wrap">
        <Text c="inherit" fw={600} size="sm">
          {warning.title}
        </Text>
        <Badge
          c={WARNING_BADGE_TEXT_COLOR}
          color="yellow"
          radius={3}
          size="xs"
          variant="light"
        >
          {warning.instances.length} found
        </Badge>
      </Flex>
      <Text c="inherit" size="xs">
        {warning.message}
      </Text>
      <Flex gap={6} wrap="wrap">
        {warning.instances.map((instance, index) => (
          <Badge
            c={WARNING_BADGE_TEXT_COLOR}
            color="yellow"
            key={`${instance}-${index}`}
            radius={3}
            size="sm"
            variant="outline"
          >
            {instance}
          </Badge>
        ))}
      </Flex>
    </Flex>
  </Flex>
);
